// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1iCns","error":"Textarea_error__1H04K","readonly":"Textarea_readonly__2CZn_","disabled":"Textarea_disabled__1muRb"};